export default __webpack_public_path__ + "static/media/instagram.9dd25141.svg";